// Thẻ bot trên Boss (07/10/2026): huy hiệu PLUGIN CŨ / KHÔNG TỰ CẬP NHẬT so với kênh phát hành (<Boss>/ext/latest.json), và dòng
// "Sao lưu plugin: lúc …, cỡ …". Hàm thuần — Boss tính trên trang web (server/src/web/pages/bots.ts), test ở tests/unit/canh-bao-plugin.test.ts.
import { SL_CU_SAU_MS, chuKichCo } from "./sao-luu-plugin";

/** Tác vụ tự cập nhật chạy MỖI GIỜ + plugin tự nạp lại khi rảnh (≤ 5 phút) → trực tuyến quá chừng này giờ sau phát hành mà vẫn bản cũ = hỏng. */
export const GIO_TU_CAP_NHAT_TOI_DA = 3;

// lichSu (09/10/2026): các bản đã phát hành + lúc phát hành (Boss đọc từ tệp kichban-<bản>.zip trong <ext>/). Lỗi thật: tính giờ từ bản MỚI NHẤT
// thì mỗi lần phát hành đồng hồ về 0 — bot 0.1.61 chậm từ 0.1.62 (~54 giờ) vẫn hiện vàng "tự lên trong khoảng 1 giờ" khi 0.1.68 vừa ra.
export interface MocPhatHanh { version: string; luc: string }
export interface BanPhatHanhNgan { version: string; luc?: string; lichSu?: MocPhatHanh[] }
export interface CanhBaoPlugin { loai: "cu" | "khong_tu_cap_nhat"; chu: string; giaiThich: string }

// Sự thật về bộ tự cập nhật do PLUGIN gửi trong bot.status.capNhat (src/background/cap-nhat.ts): version.txt chỉ bộ cập nhật trên máy
// (scripts/cap-nhat-plugin.ps1) mới ghi — zip phát hành không có → null = máy chưa từng chạy bộ cập nhật. napLai = lần quyết định tự nạp lại gần nhất.
export const KET_QUA_NAP_LAI = ["khong_co", "cho_ghi_xong", "cho_ranh", "khong_nap_duoc", "cho_sao_luu", "cho_mo_lai", "nap_lai"] as const;
export type KetQuaNapLai = (typeof KET_QUA_NAP_LAI)[number];
export interface CapNhatBot { versionTxt: string | null; dia: string | null; napLai?: { ketQua: KetQuaNapLai; lyDo?: string } }
export type BoCapNhat = "co" | "chua_cai" | "dung";

const LA_BAN = /^\d{1,6}\.\d{1,6}\.\d{1,6}(\.\d{1,12})?$/;
const LY_DO_TOI_DA = 300;
const so3 = (v: string): number[] => v.split(".").slice(0, 3).map((x) => Number(x) || 0);
function cuHon(a: string, b: string): boolean {
  const x = so3(a), y = so3(b);
  for (let i = 0; i < 3; i++) { if ((x[i] ?? 0) < (y[i] ?? 0)) return true; if ((x[i] ?? 0) > (y[i] ?? 0)) return false; }
  return false;
}

/** Bot chậm từ khi nào: bản ĐẦU TIÊN trong lịch sử mới hơn `ban` (≤ bản mới nhất). Lịch sử thiếu/hỏng → lúc của bản mới nhất (cách cũ). */
function mocCham(ban: string, ph: BanPhatHanhNgan): { t: number; dauTien?: string; soBan?: number } {
  const ls = (Array.isArray(ph.lichSu) ? ph.lichSu : [])
    .filter((m) => typeof m?.version === "string" && LA_BAN.test(m.version) && Number.isFinite(Date.parse(m.luc)) && cuHon(ban, m.version) && !cuHon(ph.version, m.version))
    .sort((a, b) => (cuHon(a.version, b.version) ? -1 : cuHon(b.version, a.version) ? 1 : 0));
  const dau = ls[0];
  if (dau) return { t: Date.parse(dau.luc), dauTien: dau.version, soBan: ls.length };
  return { t: ph.luc ? Date.parse(ph.luc) : NaN };
}
const gioSau = (moc: number, lastSeenAt: string | null | undefined): number => {
  const thay = lastSeenAt ? Date.parse(lastSeenAt) : NaN;
  return Number.isFinite(moc) && Number.isFinite(thay) ? (thay - moc) / 3600_000 : NaN;
};

/** Bộ tự cập nhật trên máy bot: có / chưa cài / đã cài nhưng ngừng chạy (version.txt tụt sau bản đã phát hành quá N giờ). null = plugin chưa báo. */
export function tinhTrangBoCapNhat(cn: CapNhatBot | null | undefined, ph: BanPhatHanhNgan | null | undefined, lastSeenAt: string | null | undefined, gioToiDa = GIO_TU_CAP_NHAT_TOI_DA): BoCapNhat | null {
  if (!cn) return null;
  if (!cn.versionTxt) return "chua_cai";
  if (!ph?.version || !cuHon(cn.versionTxt, ph.version)) return "co";
  return gioSau(mocCham(cn.versionTxt, ph).t, lastSeenAt) >= gioToiDa ? "dung" : "co";
}

/** Đọc an toàn bot.status.capNhat (dữ liệu do bot gửi): sai kiểu → bỏ trường, lý do cắt ngắn. Không phải object → null. */
export function docCapNhatBot(raw: unknown): CapNhatBot | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  const ban = (v: unknown): string | null => (typeof v === "string" && LA_BAN.test(v) ? v : null);
  const out: CapNhatBot = { versionTxt: ban(o.versionTxt), dia: ban(o.dia) };
  const nl = o.napLai as Record<string, unknown> | null | undefined;
  if (nl && typeof nl === "object" && (KET_QUA_NAP_LAI as readonly unknown[]).includes(nl.ketQua)) {
    out.napLai = { ketQua: nl.ketQua as KetQuaNapLai, ...(typeof nl.lyDo === "string" && nl.lyDo ? { lyDo: nl.lyDo.slice(0, LY_DO_TOI_DA) } : {}) };
  }
  return out;
}

const SUA = "chạy lệnh Cách 2 ở trang Tải plugin trên máy đó (một lần). Đừng gỡ tiện ích (gỡ là mất dữ liệu trên máy).";
const DANG_CHO: ReadonlySet<KetQuaNapLai> = new Set(["cho_ghi_xong", "cho_ranh", "cho_sao_luu", "cho_mo_lai"]);

export function canhBaoPlugin(extVersion: string | null | undefined, moiNhat: BanPhatHanhNgan | null | undefined, lastSeenAt: string | null | undefined, capNhat?: CapNhatBot | null, gioToiDa = GIO_TU_CAP_NHAT_TOI_DA): CanhBaoPlugin | null {
  if (!extVersion || !LA_BAN.test(extVersion) || !moiNhat?.version || !cuHon(extVersion, moiNhat.version)) return null;
  const moc = mocCham(extVersion, moiNhat);
  const gc = moc.dauTien ? `, chậm ${moc.soBan} bản (từ bản ${moc.dauTien} phát hành ${gioVn(new Date(moc.t).toISOString()) ?? "?"})` : "";
  const dau = `Bot chạy plugin ${extVersion}, bản mới nhất ${moiNhat.version}${gc}`;
  const do_ = (giaiThich: string): CanhBaoPlugin => ({ loai: "khong_tu_cap_nhat", chu: "không tự cập nhật", giaiThich });
  const bc = tinhTrangBoCapNhat(capNhat, moiNhat, lastSeenAt, gioToiDa);
  if (bc === "chua_cai") return do_(`${dau} — máy này chưa cài bộ tự cập nhật (plugin cài tay từ tệp zip): ${SUA}`);
  if (bc === "dung") return do_(`${dau} — bộ tự cập nhật trên máy đã ngừng chạy (bản cuối nó tải về: ${capNhat!.versionTxt}): ${SUA}`);
  const nl = capNhat?.napLai;
  if (nl?.ketQua === "khong_nap_duoc") return do_(`${dau} — đã tải bản mới về máy nhưng không tự nạp lại được: ${nl.lyDo ?? "không rõ lý do"}`);
  const cho = nl && DANG_CHO.has(nl.ketQua) && nl.lyDo ? ` Đã tải bản mới về máy, đang chờ: ${nl.lyDo}.` : "";
  const h = gioSau(moc.t, lastSeenAt);
  if (h >= gioToiDa) return do_(`${dau}; bot còn trực tuyến ${Math.floor(h)} giờ sau đó mà chưa lên — máy này chưa có hoặc đã hỏng bộ tự cập nhật:${cho} ${SUA}`);
  return { loai: "cu", chu: "plugin cũ", giaiThich: `${dau} — máy có bộ tự cập nhật sẽ tự lên bản mới trong khoảng 1 giờ khi trực tuyến và rảnh.${cho}` };
}

const hai = (n: number): string => String(n).padStart(2, "0");
/** "10:05 07/10" theo giờ Việt Nam (UTC+7, không đổi giờ mùa hè). */
export function gioVn(iso: string): string | null {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return null;
  const d = new Date(t + 7 * 3600_000);
  return `${hai(d.getUTCHours())}:${hai(d.getUTCMinutes())} ${hai(d.getUTCDate())}/${hai(d.getUTCMonth() + 1)}`;
}

export function dongSaoLuu(sl: { luc: string; kichCo: number } | null | undefined, now: number): { chu: string; muc: "chua" | "ok" | "cu" } {
  if (!sl) return { chu: "Sao lưu plugin: chưa có", muc: "chua" };
  const t = Date.parse(sl.luc);
  const g = gioVn(sl.luc);
  return { chu: `Sao lưu plugin: ${g ?? "?"} · ${chuKichCo(sl.kichCo)}`, muc: Number.isFinite(t) && now - t <= SL_CU_SAU_MS ? "ok" : "cu" };
}
